import { Controller } from '@hotwired/stimulus'
import L from 'leaflet'

// Fix Leaflet default icon paths
delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png'
})

export default class extends Controller {
  static targets = ['map']
  static values = {
    zones: { type: Array, default: [] },
    restaurantLat: Number,
    restaurantLng: Number,
    radius: { type: Number, default: 50000 },
    center: { type: Array, default: [43.17, 44.82] },
    zoom: { type: Number, default: 10 }
  }

  connect () {
    this.initMap()
    this.addRestaurantMarker()
    this.addRadiusCircle()
    this.addZones()
    this.fitBounds()
  }

  disconnect () {
    if (this.map) {
      this.map.remove()
      this.map = null
    }
  }

  initMap () {
    const center = this.hasRestaurantLatValue && this.hasRestaurantLngValue
      ? [this.restaurantLatValue, this.restaurantLngValue]
      : this.centerValue

    this.map = L.map(this.mapTarget).setView(center, this.zoomValue)

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      maxZoom: 19
    }).addTo(this.map)
  }

  addRestaurantMarker () {
    if (!this.hasRestaurantLatValue || !this.hasRestaurantLngValue) return

    const icon = L.divIcon({
      html: '<i class="fas fa-store" style="color: #e74c3c; font-size: 24px;"></i>',
      className: 'restaurant-marker',
      iconSize: [24, 24],
      iconAnchor: [12, 12]
    })

    L.marker([this.restaurantLatValue, this.restaurantLngValue], { icon })
      .addTo(this.map)
      .bindPopup('Ресторан')
  }

  addRadiusCircle () {
    if (!this.hasRestaurantLatValue || !this.hasRestaurantLngValue) return

    this.radiusCircle = L.circle([this.restaurantLatValue, this.restaurantLngValue], {
      radius: this.radiusValue,
      color: '#999',
      fillColor: '#999',
      fillOpacity: 0.08,
      dashArray: '10, 10',
      weight: 2
    }).addTo(this.map)
  }

  addZones () {
    this.zonesValue.forEach(zone => {
      if (!zone.coordinates || zone.coordinates.length < 3) return

      const polygon = L.polygon(zone.coordinates, {
        color: zone.color || '#3388ff',
        fillOpacity: 0.3,
        weight: 2
      }).addTo(this.map)

      polygon.bindTooltip(zone.name, {
        permanent: true,
        direction: 'center',
        className: 'zone-label'
      })
    })
  }

  fitBounds () {
    const bounds = L.latLngBounds([])

    if (this.radiusCircle) {
      bounds.extend(this.radiusCircle.getBounds())
    } else if (this.hasRestaurantLatValue && this.hasRestaurantLngValue) {
      bounds.extend([this.restaurantLatValue, this.restaurantLngValue])
    }

    this.zonesValue.forEach(zone => {
      if (zone.coordinates) {
        zone.coordinates.forEach(c => bounds.extend(c))
      }
    })

    if (bounds.isValid()) {
      this.map.fitBounds(bounds, { padding: [30, 30] })
    }
  }
}
